
// Constants for select options
export const genderOptions = ["Male", "Female", "Non-binary", "Prefer not to say", "Other"];
export const educationLevels = [
    "Did not complete High School", "High School Diploma or GED", "Some College, No Degree",
    "Associate's Degree", "Bachelor's Degree", "Master's Degree",
    "Doctoral Degree (PhD, EdD)", "Professional Degree (MD, JD, DDS)",
    "Trade/Vocational Certification", "Other",
];
export const employmentStatusOptions = [
    "Employed Full-Time", "Employed Part-Time", "Self-Employed", "Unemployed",
    "Retired", "Student", "Unable to Work (Disability)", "Homemaker", "Other",
];
export const countryOptions = [
    { value: "US", label: "United States" },
    { value: "Canada", label: "Canada" },
];
export const usStates = [
    "Alabama", "Alaska", "Arizona", "Arkansas", "California", "Colorado", "Connecticut", "Delaware", "Florida", "Georgia",
    "Hawaii", "Idaho", "Illinois", "Indiana", "Iowa", "Kansas", "Kentucky", "Louisiana", "Maine", "Maryland",
    "Massachusetts", "Michigan", "Minnesota", "Mississippi", "Missouri", "Montana", "Nebraska", "Nevada", "New Hampshire", "New Jersey",
    "New Mexico", "New York", "North Carolina", "North Dakota", "Ohio", "Oklahoma", "Oregon", "Pennsylvania", "Rhode Island", "South Carolina",
    "South Dakota", "Tennessee", "Texas", "Utah", "Vermont", "Virginia", "Washington", "West Virginia", "Wisconsin", "Wyoming", "District of Columbia", "Puerto Rico", "Guam", "American Samoa", "U.S. Virgin Islands", "Northern Mariana Islands"
];
export const canadianProvinces = [
    "Alberta", "British Columbia", "Manitoba", "New Brunswick", "Newfoundland and Labrador", "Nova Scotia", "Ontario", "Prince Edward Island", "Quebec", "Saskatchewan",
    "Northwest Territories", "Nunavut", "Yukon"
];

export const claimantSectorOptions = [
    { value: "Public sector", label: "Public sector" },
    { value: "Private sector", label: "Private sector" },
    { value: "Not sure / Not applicable", label: "Not sure / Not applicable" },
];
